import React from "react";
import { useOutletContext } from "react-router-dom";
import { LifeBuoy, Briefcase, ExternalLink } from "lucide-react";

export default function Soporte() {
  const ctx = useOutletContext<any>();
  const technical = ctx?.features?.technical_support;
  const technicalUrl = technical?.config?.url;
  const technicalReady = !!(technical?.available && technicalUrl);
  const advisor = ctx?.features?.commercial_advisor;
  const advisorUrl = advisor?.config?.url;
  const advisorReady = !!(advisor?.available && advisorUrl);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="support-page">
      <div>
        <h1 className="text-3xl font-serif font-medium">Soporte</h1>
        <p className="text-sm text-slate-500 mt-1">
          Elige el canal correcto según tu consulta: soporte técnico de FitRewards o asesoría comercial de Armony.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        <div className="card-obsidian p-6" data-testid="support-technical-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0">
              <LifeBuoy className="w-5 h-5 text-gold" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900">Soporte técnico Motivy</h3>
          </div>
          {technicalReady ? (
            <>
              <p className="text-sm text-slate-500 mb-4">
                Para problemas de acceso, puntos o funcionamiento de la plataforma, contacta a Motivy.
              </p>
              <a
                href={technicalUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="support-technical-link"
                className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:underline"
              >
                Hablar con soporte <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </>
          ) : (
            <p className="text-sm text-slate-500">
              Para problemas de acceso, puntos o funcionamiento de la plataforma, contacta a Motivy.
            </p>
          )}
        </div>

        <div className="card-obsidian p-6" data-testid="support-commercial-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center shrink-0">
              <Briefcase className="w-5 h-5 text-gold" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900">Asesoría comercial Armony</h3>
          </div>
          {advisorReady ? (
            <>
              <p className="text-sm text-slate-500 mb-4">
                Para contratar, actualizar o cancelar tu plan, habla con un asesor comercial de Armony.
              </p>
              <a
                href={advisorUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="support-commercial-link"
                className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:underline"
              >
                Hablar con un asesor <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </>
          ) : (
            <p className="text-sm text-slate-500">
              Este canal aún no está disponible. Vuelve a intentarlo más tarde.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
